<script lang="ts">
	import { onMount } from 'svelte';

	let { pixelId } = $props<{ pixelId: string }>();

	type FbqFunction = (...args: any[]) => void;
	type FbqWindow = Window &
		typeof globalThis & {
			fbq?: FbqFunction & {
				callMethod?: FbqFunction;
				queue: any[];
				loaded: boolean;
				version: string;
				push: FbqFunction;
			};
			_fbq?: FbqFunction;
		};

	onMount(() => {
		const load = () => {
			const win = window as FbqWindow;
			if (win.fbq) return;

			// Setup du stub fbq — exactement comme le code officiel Facebook
			const fbq: any = function (...args: any[]) {
				if (fbq.callMethod) {
					fbq.callMethod(...args);
				} else {
					fbq.queue.push(args);
				}
			};
			fbq.push = fbq;
			fbq.loaded = true;
			fbq.version = '2.0';
			fbq.queue = [];

			win.fbq = fbq;
			win._fbq = fbq;

			// Appels immédiats — mis en queue jusqu'au chargement du script
			fbq('init', pixelId);
			fbq('track', 'PageView');

			// Injection du script
			const script = document.createElement('script');
			script.async = true;
			script.src = 'https://connect.facebook.net/en_US/fbevents.js';
			script.onerror = (err) => console.error('[FB Pixel] Erreur de chargement ❌', err);
			document.body.appendChild(script);
		};

		if ('requestIdleCallback' in window) {
			requestIdleCallback(load);
		} else {
			setTimeout(load, 2500);
		}
	});
</script>
